import { render, staticRenderFns } from "./MessageItemEmail.vue?vue&type=template&id=daf16214"
import script from "./MessageItemEmail.vue?vue&type=script&lang=js"
export * from "./MessageItemEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports